import React from "react";
import history from "../../../utils/history";
import { RideButton, RideGlArrowBack } from '@rimac-seguros/ride-system-components';
import "./styles.scss";

const BackStep = (props) => {
    const { prevStep, textBack } = props;
    return (
        <div className="back-step">
            <RideButton
                text={textBack || "Volver"}
                variant="text-secondary"
                glyph={<RideGlArrowBack size="small" />}
                glyphPosition="left"
                size="large"
                onClick={() => history.push("" + prevStep)}
            />
        </div>
    );
};

export default BackStep;
